import { defineMessages } from 'react-intl';

export default defineMessages({
  EMPTY_STATE_RESOURCES_TITLE: {
    defaultMessage: "Aucune ressource pour l'instant",
  },
} as const);
